import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import ServiceDetail from "./pages/ServiceDetail";
import Forbidden from "./pages/Forbidden";
import NotFound from "./pages/NotFound";
import TestImages from "./pages/TestImages";

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex min-h-screen flex-col bg-white text-neutral-900 antialiased selection:bg-[#C2A679]/30 selection:text-neutral-900">
        <ScrollToTop />
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/ydelser/:id" element={<ServiceDetail />} />
            <Route path="/test-images" element={<TestImages />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
